<template>
  <div class="standardpage">
    <b-card>
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="queue.icon" class="mr-1"></i>
            <span>{{ queue.title }}</span></b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">

              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Queued At" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="created_at" v-model="created_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="created_at = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Type" label-for="type" label-cols="12">
                  <treeselect instanceId="type" type="number" v-model="type" :clearable="true" :multiple="true"
                    :options="type_options"></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                  </b-input-group>
                  <b-input-group>
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested>
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Document ( Paste List )" label-size="sm">
                  <!-- <b-input-group>
                    <b-form-input v-model="name" :debounce="queue.debounce" placeholder="Document" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!name" @click="name = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group> -->
                  <b-input-group class="z-0">
                    <b-form-tags input-id="document" v-model="name" tag-variant="primary" separator=" ,;"
                      placeholder="Document" size="sm" class="h-29" add-button-text="+" add-on-change remove-on-delete
                      add-button-variant="outline-primary"></b-form-tags>

                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="name = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="agent" :debounce="queue.debounce" placeholder="Agent" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Ticket No (XPath)" label-size="sm" id="ticketno">
                  <b-input-group>
                    <b-form-input v-model="ticketno" :debounce="queue.debounce" placeholder="Ticket No (XPath)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!ticketno" @click="ticketno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Passenger (XPath)" label-size="sm" id="passenger">
                  <b-input-group>
                    <b-form-input v-model="passenger" :debounce="queue.debounce" placeholder="Passenger (XPath)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!passenger" @click="passenger = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Invoice No? ( Paste List )" label-for="reflist" label-cols="12"> <b-input-group
                    class="treeselect_all justify-content-end pr-2px">
                    <b-form-checkbox-group id="isinvoiced" v-model="isinvoiced" :options="options_isinvoiced" size="sm"
                      value-field="id" text-field="label" name="radio-options" class="z-0" style="padding-top: 0.2em">
                    </b-form-checkbox-group>
                  </b-input-group>
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist" v-model="invoiceno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="invoiceno = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Your Ref / PO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="yourref" :debounce="queue.debounce" placeholder="Your Ref" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Status" label-for="status" label-cols="12">
                  <treeselect instanceId="status" type="number" v-model="status" :clearable="true" :multiple="true"
                    :options="status_options"></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Message" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="message" :debounce="queue.debounce" placeholder="Message" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!message" @click="message = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="queue" :icon="queue.icon" :selectall="queue.selectall"
            :toolbarlibrary="queue.toolbarlibrary" :tools="queue.tools" :badges="queue.badges" :fields="queue.fields"
            :items="queue.items" :busy="queue.busy" :offset="queue.offset" :limit="queue.limit" :page="queue.page"
            :showpages="true" :selectmode="'multi'" @load="queue_load" @click="queue_click" @select="queue_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="queue.selected" :queued="usequeue" :intray="intray" :config="cconfig"
          @discard="queue_click('discard')"></component>
      </div>

      <b-row class="px-3">
        <b-col>
          <b-alert :show="message2 ? true : false" variant="success">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                <span v-html="message2"></span></b-col></b-row>
          </b-alert></b-col>
      </b-row>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import QueueXml from "./Components/QueueXml";
import QueueInvoice from "./Components/QueueInvoice";
import TicketsDraft from "../Tickets/Components/TicketsDraft";
import QueueImport from "./Components/QueueImport";
import QueueEdit from "./Components/QueueEdit";

export default {
  name: "Queue",
  components: {
    QueueXml,
    QueueInvoice,
    TicketsDraft,
    QueueImport,
    QueueEdit
  },
  watch: {
    async created_at() {
      await this.queue_load(0);
    },
    async name() {
      await this.queue_load(0);
    },
    async eventcode() {
      await this.queue_load(0);
    },
    async slac() {
      await this.queue_load(0);
    },
    async agent() {
      await this.queue_load(0);
    },
    async invoiceno() {
      await this.queue_load(0);
    },
    async isinvoiced() {
      await this.queue_load(0);
    },
    async yourref() {
      await this.queue_load(0);
    },
    async status() {
      await this.queue_load(0);
    },
    async type() {
      await this.queue_load(0);
    },
    async ticketno() {
      await this.queue_load(0);
    },
    async passenger() {
      await this.queue_load(0);
    },
    async message() {
      await this.queue_load(0);
    },
  },
  data() {
    return {
      busy: false,
      name: [],
      message2: null,
      created_at: {
        startDate: this.$moment().startOf("year").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      status: [],
      status_options: [
        { id: "0", label: "Posted" },
        { id: "1", label: "Pending" },
        { id: "2", label: "Error" },
      ],
      type: [],
      type_options: [
        { id: "0", label: "BulkticketV" },
        { id: "1", label: "BulkticketB" },
        { id: "2", label: "BarclayCard" },
        { id: "3", label: "ConfermaPay" },
      ],
      options_isinvoiced: [
        { id: '1', label: 'Yes' },
        { id: '0', label: 'No' },
      ],
      data: null,
      slac: [],
      slaclike: false,
      eventcode: [],
      ticketno: null,
      passenger: null,
      agent: null,
      message: null,
      invoiceno: [],
      isinvoiced: "0",
      yourref: null,
      usequeue: true,
      intray: null,
      queue: {
        title: "Zhold Queue",
        icon: "fa fa-stack-overflow text-warning",
        selectall: false,
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-ticket text-orange",
            position: "toolbar",
            action: "fee",
            label: "Fee",
            disabled: true,
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-ticket text-orange",
            position: "toolbar",
            action: "priced",
            label: "Priced",
            disabled: true,
            component: {
              name: "",
            },
          },
        ],
        tools: "go,filter,import,export,edit,deleteconfirm,xml,submit,priced,fee,invoice",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "created_at",
            label: "Queued At",
            sortable: true,
            class: "text-center w-100px",
            // formatter: (value, key, item) => {
            //   let result = "";
            //   if (value) {
            //     result = this.$moment
            //       .unix(value / 1000)
            //       .utc(false)
            //       .format("DD/MM/YYYY HH:mm:SS");
            //   }
            //   return result;
            // },
          },
          {
            key: "type",
            label: "Source Type",
            sortable: true,
          },
          {
            key: "name",
            label: "Document Id",
            sortable: true,
            class: "text-center",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          {
            key: "value",
            label: "Value",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
          },
          {
            key: "message",
            label: "Last Message",
            sortable: true,
            class: "text-center",
          },
          {
            key: "invoiceno",
            label: "InvoiceNo",
            sortable: true,
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
            class: "text-center",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "name",
            type: "pill",
            class: "secondary",
          },
          {
            key: "status",
            type: "badge",
            Posted: "success",
            Pending: "warning",
            Error: "danger",
            formatter: (value, key, item) => {
              switch (value) {
                case 0:
                  return "Posted";
                case 1:
                  return "Pending";
                case 2:
                  return "Error";
                default:
                  return value;
              }
            },
          },
          {
            key: "type",
            type: "badge",
            BulkticketV: "purple",
            BulkticketB: "purple",
            BarclayCard: "info",
            ConfermaPay: "white",
            formatter: (value, key, item) => {
              switch (value) {
                case 0:
                  return "BulkticketV";
                case 1:
                  return "BulkticketB";
                case 2:
                  return "BarclayCard";
                case 3:
                  return "ConfermaPay";
                default:
                  return value;
              }
            },
          },
        ],
        items: [],
        selected: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();

  },
  async activated() {
    await this.queue_load()
  },
  async deactivated() {
    // console.log('Queue deactivated')
  },
  methods: {
    accessdenied() {
      this.queue.denied = [];
      if (!this.user.permissions.includes("queue.delete")) {
        this.queue.denied.push("delete");
      }
      if (!this.user.permissions.includes("queue.save")) {
        this.queue.denied.push("save");
        this.queue.denied.push("import");
      }
    },
    async queue_load(offset, limit, page) {

      this.message2 = null

      let state = this.queue;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        name: this.name.length > 0 ? this.name.join(",") : null,
        created_at: [
          this.created_at.startDate
            ? this.$moment(this.created_at.startDate).format("YYYY-MM-DD")
            : null,
          this.created_at.endDate
            ? this.$moment(this.created_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        ticketno: this.ticketno,
        passenger: this.passenger,
        agent: this.agent,
        message: this.message,
        invoiceno: this.invoiceno.length > 0 ? this.invoiceno.join(",") : null,
        isinvoiced: this.isinvoiced ? this.isinvoiced == "1" ? true : false : null,
        yourref: this.yourref,
        status: this.status.length > 0 ? this.status.join(",") : null,
        type: this.type.length > 0 ? this.type.join(",") : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query queue(
              $limit: Int
              $offset: Int
              $name: String
              $created_at: [String]
              $eventcode: String
              $ticketno: String
              $passenger: String
              $slac: String
              $agent: String
              $message: String
              $invoiceno: String
              $yourref: String
              $status: String
              $type: String
              $isinvoiced: Boolean
            ) {
              queue(
                limit: $limit
                offset: $offset
                name: $name
                created_at: $created_at
                eventcode: $eventcode
                ticketno: $ticketno
                passenger: $passenger
                slac: $slac
                agent: $agent
                message: $message
                invoiceno: $invoiceno
                yourref: $yourref
                status: $status
                type: $type
                isinvoiced: $isinvoiced
              ) {
                id
                name
                eventcode
                slac
                agent
                value
                invoiceno
                status
                type
                message
                data
                created_at
                updated_by
                updated_at
                rows
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.queue
        } else {
          state.items = []
          state.items = response.data.queue;
        }


        // if (limit == 0) {
        //   this.queue.selected = this.cleanit(response.data.queue);
        // } else {
        //   this.queue.items = response.data.queue;
        // }


      } catch (error) {
        console.log(error);
      }
      this.$store.dispatch("queued")
      this.usequeue = true
      state.busy = false;
    },

    async queue_click(a, ss) {

      let state = this.queue;

      switch (a) {
        case "selectall":
          await this.queue_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.queue_load();
          break;
        case "edit":
          this.component = "QueueEdit";
          break;
        case "import":
          this.component = "QueueImport";
          break;
        case "fee":
          ss = await this.queue_tickets("ticketfee")
          if (ss.length > 0) {
            this.intray = "ticketfee"
            state.selected = ss
            this.component = "TicketsDraft";
          }
          break;
        case "priced":
          ss = await this.queue_tickets("priced")
          if (ss.length > 0) {
            this.intray = "priced"
            state.selected = ss
            this.component = "TicketsDraft";
          }
          break;
        case "submit":
          if (ss.length > 0) {
            this.intray = null
            this.component = "TicketsDraft";
          }
          break;
        case "invoice":
          // this.component = "QueueInvoice";

          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.message2 = null
              this.component = "QueueInvoice";
            } else {
              this.message2 = "Invoice has not been posted yet! use <i class='fa fa-paper-plane text-info'></i> Draft to review an invoice."
              this.component = null;
            }
          }
          break;
        case "xml":
          this.component = "QueueXml";
          break;
        case "delete":
          this.queue_deleteit(ss);
          break;
      }
    },
    queue_select(ss, tools) {
      this.message2 = null
      console.log("queue_select", ss);

      let state = this.queue;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export", "import", "fee", "priced"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["xml", "invoice", "edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "submit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
    async queue_tickets(inventory_type) {

      let ss = []

      let variables = {
        offset: 0,
        limit: 0,
        dateissued: [
          this.created_at.startDate
            ? this.$moment(this.created_at.startDate).format("YYYY-MM-DD")
            : null,
          this.created_at.endDate
            ? this.$moment(this.created_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        isinvoiced: this.isinvoiced ? this.isinvoiced == "1" ? true : false : null,
        type: "ticket",
        inventory_type,
        mssql: true,
      }

      //QUERY
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $mssql: Boolean
              $offset: Int
              $limit: Int
              $dateissued: [String]            
              $isinvoiced: Boolean
              $type: String             
              $inventory_type: String          
            ) {
              tickets(
                mssql: $mssql
                offset: $offset
                limit: $limit
                dateissued: $dateissued              
                isinvoiced: $isinvoiced
                type: $type             
                inventory_type: $inventory_type
               
              ) {
                id               
                ticketno                    
              }
            }
          `,
          variables,
        });

        ss = this.cleanit(response.data.tickets);
        this.usequeue = false

      } catch (error) {
        console.log(error);
      }

      return ss

    },
    async queue_deleteit(ss) {
      console.log('queue_deleteit', ss)

      this.queue.busy = true;

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation queue_delete($rows: [Queue_input]) {
              queue_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.queue_load(0);

      this.queue.busy = false;

    }
  },
};
</script>

<style></style>